<template>
  <div class="sharing">
    <div v-if="sharing_count" class="columns">
      <div class="column is-12">
        <div class="field has-addons">
          <p class="control is-full-width">
            <input
              v-model="keyword"
              placeholder="Search ..."
              class="input is-medium"
            />
          </p>
        </div>
      </div>
    </div>
    <div v-if="courses.filter(function(item) { return item.status === 'created'; }).length" class="notification is-info" style="z-index: 0" v-html="$t('reports.received-courses.recall-notice')"></div>
    <table
      v-if="sharing_count"
      class="table is-striped is-hoverable is-fullwidth is-vertical-centered"
    >
      <thead>
        <tr>
          <th class="is-1">
            <input type="checkbox" class="checkbox" @click="checkVisible" />
            #
          </th>
          <th class="is-date">
            <a @click.prevent="orderBy('send_at')">
              <span v-html="$t('quick-share.send-at')" />
            </a>
            <i
              v-if="sort.column === 'send_at'"
              :class="`sort-icon fa fa-sort-alpha-${sort.dir}`"
            />
          </th>
          <th class="is-date">
            <a @click.prevent="orderBy('available_till')">
              <span v-html="$t('quick-share.available-till')" />
            </a>
            <i
              v-if="sort.column === 'available_till'"
              :class="`sort-icon fa fa-sort-alpha-${sort.dir}`"
            />
          </th>
          <th>
            <a @click.prevent="orderBy('status_description')">
              <span v-html="$t('quick-share.status')" />
            </a>
            <i
                v-if="sort.column === 'status_description'"
                :class="`sort-icon fa fa-sort-alpha-${sort.dir}`"
            />
          </th>
          <th>
            <a @click.prevent="orderBy('share_to_name')">
              <span v-html="$t('quick-share.recipient')" />
            </a>
            <i
              v-if="sort.column === 'share_to_name'"
              :class="`sort-icon fa fa-sort-alpha-${sort.dir}`"
            />
          </th>
          <th class="is-right is-3">
            <Dropdown class="is-centered">
              <span slot="title">
                Per page
              </span>
              <a
                v-for="i in perPage"
                :key="i"
                :class="i == per_page ? 'is-active' : ''"
                class="dropdown-item"
                @click="per_page = i"
                v-text="i"
              />
            </Dropdown>
            <Dropdown class="is-left">
              <a
                class="dropdown-item"
                @click="resendSelected"
                v-text="$t('quick-share.resend-selected')"
              />
              <a
                class="dropdown-item"
                @click="cancelSelected"
                v-text="$t('quick-share.cancel-selected')"
              />
            </Dropdown>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(course, key) in filteredData" :key="key">
          <td>
            <input v-model="course.checked" type="checkbox" class="checkbox" />
            <span v-text="key + 1" />
          </td>
          <td v-text="course.send_at" />
          <td v-text="course.available_till" />
          <td v-text="course.status_description" />
          <td
            v-html="
              course.share_to_name ? course.share_to_name : course.share_to
            "
          />
          <td class="is-right">
            <a
              v-if="course.share_type == 'ticket'"
              :href="`/tickets/${course.share_to}`"
              target="_blank"
              class="button is-info"
            >
              <i class="fa fa-ticket" />
              &nbsp;&nbsp;Print Ticket
            </a>

            <button
              v-if="course.share_type === 'email' && course.status !== 'created'"
              type="button"
              class="button is-purple"
              @click="resend(course)"
            >
              <i class="fa fa-share-square-o" />
              &nbsp; Resend
            </button>

            <button v-if="course.status !== 'created'"
              type="button"
              class="button is-danger"
              @click="cancel(course)"
            >
              <i class="fa fa-remove" />
              &nbsp; Cancel
            </button>

            <button v-if="course.status === 'created'"
                    :title="$t('reports.received-courses.recall-notice')"
                    type="button"
                    class="button is-danger"
                    @click="recall(course)"
            >
              <i class="fa fa-remove" />
              &nbsp; Cancel
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="sharing_count" class="columns is-centered">
      <div class="column is-three-quarters">
        <ul class="pagination">
          <li class="page-item">
            <a
              class="page-link"
              href=""
              @click.prevent="setPage(current_page - 1)"
            >
              «
            </a>
          </li>
          <li
            v-for="i in pages"
            :key="i"
            :class="{ active: current_page === i }"
            class="page-item"
            @click.prevent="setPage(i)"
          >
            <a v-if="current_page !== i" class="page-link" href="" v-html="i" />

            <span v-if="current_page === i" class="page-link" v-html="i" />
          </li>
          <li class="page-item">
            <a
              class="page-link"
              href=""
              @click.prevent="setPage(current_page + 1)"
            >
              »
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash';
import axios from 'axios';
import moment from 'moment';
import ListPagination from 'mixins/ListPagination';
import Dropdown from 'components/Html/common/Dropdown';

export default {
  name: 'Sharing',

  components: {
    Dropdown
  },

  mixins: [ListPagination],

  props: {
    sharing: { required: true, type: Array },
    only_shared: { required: false, type: Boolean, default: false }
  },

  data() {
    return {
      courses: this.sharing,
      all_checked: false,
      processing: false,
      sort: {
        column: 'send_at',
        dir: 'desc'
      }
    };
  },

  computed: {
    items() {
      return orderBy(this.courses, [this.sort.column], [this.sort.dir]);
    },

    sharing_count() {
      return this.courses.length;
    }
  },

  methods: {
    filter(item) {
      const str = item.share_to_name || '';
      const test = str
        .toLowerCase()
        .includes(this.keyword.trim().toLocaleLowerCase());

      if (this.only_shared) {
        return item.share && test;
      }

      return test;
    },

    orderBy(col) {
      this.sort = {
        column: col,
        dir: this.sort.dir === 'asc' ? 'desc' : 'asc'
      };
    },

    checkVisible() {
      this.all_checked = !this.all_checked;

      this.filteredData.forEach(i => {
        i.checked = this.all_checked;
      });
    },

    resendSelected() {
      const $this = this;
      Swal.fire({
        title: 'Are you sure you want to resend?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes!'
      }).then(result => {
        if (result.value) {
          $this.filteredData.forEach(course => {
            if (course.checked && course.status !== 'created') {
              $this.resend(course);
            }
          });
        }
      });
    },

    cancelSelected() {
      const $this = this;
      Swal.fire({
        title: 'Are you sure?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes!'
      }).then(result => {
        if (result.value) {
          $this.filteredData.forEach(course => {
            if (course.checked) {
              if (course.status === 'created') {
                $this.recall(course);
              } else {
                $this.cancel(course);
              }
            }
          });
        }
      });
    },

    resend(course) {
      axios
        .patch(`/quick-share/resend/${course.id}`)
        .then(() => {
          course.send_at = moment().format('YYYY-MM-DD HH:mm');
          flash(
            this.$t('quick-share.resend-success', { email: course.share_to }),
          );
        })
        .catch(() => {
          error(
            this.$t('quick-share.resend-error', { email: course.share_to }),
          );
        });
    },

    cancel(course) {
      axios
        .delete(`/quick-share/${course.id}`)
        .then(() => {
          flash(this.$t('quick-share.cancel-success'));
          this.courses = this.courses.filter(function (item) {
            return item.id !== course.id;
          });
        })
        .catch(() => {
          error(this.$t('quick-share.cancel-error'));
        });
    },

    recall(course) {
      axios.post(`/course-recall/${course.id}`).then(() => {
        flash(this.$t('quick-share.cancel-success'));
        this.courses = this.courses.filter(function (item) {
          return item.id !== course.id;
        });
      }).catch(() => {
        error(this.$t('quick-share.cancel-error'));
      });
    }
  }
};
</script>
